import { domMax, LazyMotion, useReducedMotion } from 'framer-motion';

// ----------------------------------------------------------------------

export function MotionLazy({ children }) {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return children;
  }

  return (
    <LazyMotion strict features={domMax}>
      {children}
    </LazyMotion>
  );
}
